<div class="container">

	<div *ngIf="showStartTrial()" class="custom-alert custom-alert-info" role="alert" data-testid="plan-trial-banner">
		<div class="alert-content">
			<span class="alert-text">
				Experience Business Pro with a risk-free 14-day trial, and discover its benefits. No credit cards
				collected, just pure exploration!
			</span>
			<button type="button" vng-button variant="brand" [disabled]="clickedFreeTrial || trialRefused" data-testid="plan-start-trial"
				(click)="startFreeTrial()">Start My 14-Day Trial!</button>
		</div>
	</div>

	<div style="display:flex; justify-content:flex-start">
		<span (click)="backClicked()"
			style="display:flex; justify-content:space-between; align-items:center; cursor: pointer; margin-bottom: 10px;">
			<vng-icon name="keyboard_arrow_left" [outline]="false"></vng-icon><strong>Choose Plan</strong>
		</span>
	</div>

	<!-- issue #600 AC-7: same loading/error/ready state machine as
	     PlansDetailsComponent, applied to this page's own loadPlans() call. -->
	<div class="plans-loading" data-testid="plans-loading" *ngIf="plansLoadState === 'loading'">
		<ngx-skeleton-loader count="2" appearance="line"
			[theme]="{ 'border-radius': '8px', height: '260px', margin: '0 0 1.25rem' }"></ngx-skeleton-loader>
	</div>

	<div class="container sky-background not-eligible plans-load-error" data-testid="plans-load-error" role="alert"
		*ngIf="plansLoadState === 'error'">
		<app-empty-state icon="icon-ico-info" heading="We couldn't load our plans"
			subtext="Please check your connection and try again."></app-empty-state>
		<!-- See the identical comment in plans-details.component.html (QA #602 F-1):
		     the `.plans-load-error` override below caps the icon to a sensible
		     size, so the button no longer needs position:relative/z-index. -->
		<div style="display:flex; justify-content:center">
			<button vng-button variant="primary" type="button" data-testid="plans-load-retry"
				(click)="retryPlansLoad()">Try again</button>
		</div>
	</div>

	<div style="display:flex; justify-content:space-between; align-items:flex-start; gap:1.25rem"
		data-testid="plans-ready-region" tabindex="-1"
		*ngIf="plansLoadState === 'ready'">
		<vng-card variant="outline" class="plan-selection" style="flex:1 1 100%; max-width:100%">
			<strong class="title">Your new plan</strong>
			<vng-divider></vng-divider>
			<div class="select-plan">
				<!-- R12/cheatsheet #23: a standalone, always-checked, non-interactive
				     "current plan" indicator with no group/formControl behind it today
				     (mat-radio-button here was never wired to a mat-radio-group) ->
				     a disabled vng-radio-group whose value always matches its one
				     vng-radio-button, reproducing the static checked-dot look. -->
				<vng-radio-group [ngModel]="'selected'" [disabled]="true">
					<vng-radio-button value="selected" color="primary">
						<div class="plan-details">
							<strong *ngIf="!checked || checked">{{
								planType == 'starter-yearly' ? 'Starter (Yearly Plan)' :
								planType == 'growth-yearly' ? 'Growth (Yearly Plan)' :
								planType == 'sales-pro-yearly' ? 'Business Pro (Yearly Plan)' :
								planType == 'sales-pro' ? 'Business Pro' :
								planType}}
							</strong>

							<small *ngIf="planType === subType.Starter || planType === subType.YearlyStarter">Essential
								Support, Styling, and Educational
								Content</small>
							<small *ngIf="planType === subType.Growth || planType === subType.YearlyGrowth">Enhanced
								Customization & Template FlyPlate
								Access</small>
							<small *ngIf="planType === subType.SalesPro || planType === subType.YearlySalesPro">Enhanced
								Customization & Template FlyPlate
								Access</small>
						</div>
					</vng-radio-button>
				</vng-radio-group>
			</div>
		</vng-card>
		<div class="review-changes"
			style="flex:1 1 100%; max-width:40%; display:flex; flex-direction:column; gap:1.25rem">
			<vng-card variant="outline" class="billed-duration">
				<p class="text-center dark-purple row billed">
					Billed Yearly
					<!-- "Billed Monthly" comes from vng-toggle's own [label], so it is
					     rendered as `.vng-toggle__text` and picks up the library's
					     font-size instead of this <p>'s, unlike "Billed Yearly" beside
					     it. `.fms-billed-toggle` (app.scss) hands it back. -->
					<vng-toggle [(ngModel)]="checked" (changed)="setValue($event)" label="" color="accent"
						class="dark-purple fms-billed-toggle"></vng-toggle>
					Billed Monthly
				</p>
			</vng-card>


			<!-- issue #603 AC-3: a plan/interval absent from v1/subscriptions/plans
			     shows "Contact sales" here instead of "Review Changes"/Confirm —
			     no "Due today" line, no enabled Confirm, confirmPlan() unreachable
			     from this template. Toggling to a priced interval restores the
			     normal card (isContactSalesOnly re-evaluates on every change
			     detection, driven by planType/pricing). -->
			<vng-card variant="outline" *ngIf="!isContactSalesOnly; else contactSalesCard">
				<div style="display:flex; flex-direction:column; gap:1.25rem">
					<strong class="title">Review Changes</strong>
					<ng-container [ngSwitch]="planType">
						<ng-container *ngSwitchCase="subType.Starter">
							<div class="review-row"
								style="display:flex; justify-content:space-between; align-items:flex-end">
								<div>
									<small>Plan Type</small>
									<p>{{ planType }}</p>

								</div>
								<p *ngIf="checked">${{ displayedPrice(pricing['starter']) }}/month</p>
								<p *ngIf="!checked">${{ displayedPrice(pricing['starter-yearly']) }}/year</p>
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="subType.YearlyStarter">
							<div class="review-row"
								style="display:flex; justify-content:space-between; align-items:flex-end">
								<div>
									<small>Plan Type</small>
									<p>Starter</p>

								</div>
								<p *ngIf="checked">${{ displayedPrice(pricing['starter']) }}/month</p>
								<p *ngIf="!checked">${{ displayedPrice(pricing['starter-yearly']) }}/year</p>
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="subType.Growth">
							<div class="review-row"
								style="display:flex; justify-content:space-between; align-items:flex-end">
								<div>
									<small>Plan Type</small>
									<p>{{ planType }} (Monthly Plan)</p>
								</div>
								<p *ngIf="checked">${{ displayedPrice(pricing['growth']) }}/month</p>
								<p *ngIf="!checked">${{ displayedPrice(pricing['growth-yearly']) }}/year</p>
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="subType.YearlyGrowth">
							<div class="review-row"
								style="display:flex; justify-content:space-between; align-items:flex-end">
								<div>
									<small>Plan Type</small>

									<p>Growth (Yearly Plan)</p>

								</div>
								<p *ngIf="checked">${{ displayedPrice(pricing['growth']) }}/month</p>
								<p *ngIf="!checked">${{ displayedPrice(pricing['growth-yearly']) }}/year</p>
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="subType.SalesPro">
							<div class="review-row"
								style="display:flex; justify-content:space-between; align-items:flex-end">
								<div>
									<small>Plan Type</small>
									<p>Business Pro (Monthly Plan)</p>
								</div>
								<p *ngIf="checked">${{ displayedPrice(pricing['sales-pro-monthly']) }}/month</p>
								<p *ngIf="!checked">${{ displayedPrice(pricing['sales-pro-yearly']) }}/year</p>
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="subType.YearlySalesPro">
							<div class="review-row"
								style="display:flex; justify-content:space-between; align-items:flex-end">
								<div>
									<small>Plan Type</small>
									<p>Business Pro (Yearly Plan)</p>
								</div>
								<p *ngIf="checked">${{ displayedPrice(pricing['sales-pro-monthly']) }}/month</p>
								<p *ngIf="!checked">${{ displayedPrice(pricing['sales-pro-yearly']) }}/year</p>
							</div>
						</ng-container>
					</ng-container>

					<!-- Issue #601 (human product decision): "Due today" comes from
						the same backend preview PaymentDetailsComponent uses — never
						a client-side list price (S-25). -->
					<div class="review-row" *ngIf="preview"
						style="display:flex; justify-content:space-between; align-items:flex-end">
						<strong>Due today</strong>
						<strong>${{ dueTodayDisplay }}</strong>
					</div>

					<div class="preview-loading" *ngIf="previewLoading" role="status"
						style="display:flex; justify-content:flex-end">
						<small>Calculating your price…</small>
					</div>

					<div class="preview-failed feedback error" *ngIf="previewFailed && !previewLoading"
						style="display:flex; flex-direction:column; align-items:flex-end; gap:0.5rem">
						<small>We couldn't calculate your price right now.</small>
						<button type="button" vng-button variant="secondary" (click)="retryPreview()">
							Retry
						</button>
					</div>

					<button vng-button variant="primary" (click)="confirmPlan()">
						<vng-icon name="checkmark" [outline]="false"
							style="margin-right:.5rem"></vng-icon><span>Confirm</span>
					</button>
				</div>
			</vng-card>

			<ng-template #contactSalesCard>
				<vng-card variant="outline" class="plans-load-error" data-testid="plan-contact-sales">
					<div style="display:flex; flex-direction:column; gap:1.25rem">
						<app-empty-state icon="icon-ico-info" heading="Contact sales"
							subtext="This plan is available through our sales team."></app-empty-state>
						<div style="display:flex; justify-content:center">
							<button vng-button variant="primary" type="button" data-testid="plan-contact-sales-link"
								(click)="contactSales()">Contact sales</button>
						</div>
					</div>
				</vng-card>
			</ng-template>
			<small>Payments are secured by Stripe</small>
		</div>
	</div>
</div>